import toggleWrapper from './toggle-wrapper';
import applyWrapper from './apply-wrapper';
import undoWrapper from './undo-wrapper';
import insertImage from './insert-image';
import findAndApplyWrapper from './find-and-apply-wrapper';

export default {
  toggleWrapper,
  applyWrapper,
  undoWrapper,
  insertImage,
  findAndApplyWrapper,
};
